import React from 'react'
import { Box, Typography } from '@mui/material'

import { INTERAX_COLORS } from '../../../constants/colors'
import LanguageSwitcher from '../../../components/ui/LanguageSwitcher'
import { useTranslation } from '../../../shared/hooks/useIntractionTranslate'

export const ProfileLanguageSection: React.FC = () => {
  const { t, i18n } = useTranslation()

  const currentLanguageName = i18n.language === 'sv' ? t('languages.svenska') : t('languages.english')

  return (
    <Box
      sx={{
        padding: '24px',
        backgroundColor: INTERAX_COLORS.heritageBlue40,
        borderRadius: '12px',
        marginBottom: '24px'
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontSize: '20px',
          fontWeight: 600,
          color: INTERAX_COLORS.white,
          marginBottom: '8px'
        }}
      >
        {t('navigation.languageSwitcher')}
      </Typography>
      <Typography
        sx={{
          fontSize: '14px',
          color: INTERAX_COLORS.thunderGrey,
          marginBottom: '16px'
        }}
      >
        {t('home.currentLanguage')}: {currentLanguageName}
      </Typography>
      <LanguageSwitcher />
    </Box>
  )
}
